import gql from 'graphql-tag';

export const UPDATE_CLOSE_REASON_LABEL = gql`
  mutation UpdateBPFCloseReasonLabel($id: ID!, $label: String!) {
    bpf {
      result: updateCloseReasonLabel(id: $id, label: $label) {
        error
        success
        entity {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
